import React from "react"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H4, H6, Small } from "@/components/standard/BFText"
import { Progress } from "@/components/reusables/ui/progress"
import { useQuery } from "@tanstack/react-query"
import { loanDashboardQueryOptions } from "@/queries/loan-dashboard"
import { Separator } from "@/components/reusables/ui/separator"

interface LoanStatusCardProps {
  loanId: string
  className?: string
}

export const LoanStatusCard: React.FC<LoanStatusCardProps> = ({
  loanId,
  className = "",
}) => {
  const { data: loanApp } = useQuery({
    ...loanDashboardQueryOptions(loanId),
    select: (data) => {
      return data!
    },
  })

  if (!loanApp?.milestones) {
    return null
  }

  // Calculate completion stats
  const completedMilestones = loanApp.milestones.filter(
    (milestone) => milestone.status?.toLowerCase() === "completed"
  )

  const completedCount = completedMilestones.length
  const totalCount = loanApp.milestones.length
  const progressPercentage = Math.round((completedCount / totalCount) * 100)

  return (
    <Vertical
      className={`bg-card border border-border rounded-md p-5 gap-3 ${className}`}
    >
      <Horizontal className="items-start gap-3">
        <H4 color="default">Preparing loan options</H4>
      </Horizontal>

      <Progress value={progressPercentage} className="h-3" />

      <Separator />

      <Horizontal className="items-end gap-3">
        <Horizontal className="flex-1 p-1 justify-between">
          <Small>Amount</Small>
          <H6>{loanApp.totalLoanAmount}</H6>
        </Horizontal>
        <Separator orientation="vertical" />
        <Horizontal className="flex-1 p-1 justify-between">
          <Small>Target Close</Small>
          <H6>
            {loanApp.targetCloseDate
              ? new Date(loanApp.targetCloseDate).toDateString()
              : "TBD"}
          </H6>
        </Horizontal>
      </Horizontal>
    </Vertical>
  )
}
